import { useState, useEffect } from 'react';
import { PrimaryButton, SecondaryButton } from './Buttons';
import ReviewBox from './ReviewBox';
import OfferBox from './OffersBox';
import AddReview from './AddReview';

const ShopCard = ({
    shopId,
    name,
    mainPhone,
    SecondaryPhone,
    position,
    email,
    website,
    isPremium,
    portionPrice,
    availableDays,
    shopAvatar,
    copy,
    reviews,
    offerProduct,
    owner,
    distance
}) => {

    const distanceUnit = distance / 1000 < 1 ? " m" : " km";
    const [isReviewOpen, setIsReviewOpen] = useState(false);

    const handleReviewOpen = () => {
        setIsReviewOpen(true)
    }

    const handleReviewClose = () => {
        setIsReviewOpen(false)
    }

    useEffect(() => {
        console.log('isReviewOpen: ', isReviewOpen)
    }, [isReviewOpen])

    return (
        <div className="w-full lg:w-[450px] rounded-xl border border-orange-500 shadow-xl overflow-hidden flex flex-col p-8 relative">
            <div className='flex flex-col md:items-center gap-8 mb-8'>

                <div className='font-bold text-orange-500 p-2 border border-cyan-600 rounded-lg w-fit md:self-end'>a <span className='text-cyan-600'>{distance / 1000 >= 1 ? ((distance / 1000).toFixed(1)) : (distance.toFixed(0))}</span>{distanceUnit} di distanza da te</div>

                {/* Shop info */}
                <h3 className='font-serif text-cyan-600 md:text-center leading-8'>{name}</h3>
                <div className='flex flex-col md:items-center gap-2'>
                    <div className='flex gap-2'>
                        <i class="fi fi-sr-city text-orange-500"></i>
                        {position && <p>{position.city}</p>}
                    </div>
                    <div className='flex gap-2'>
                        <i class="fi fi-sr-marker text-orange-500"></i>
                        {position && <p>{position.address}</p>}
                    </div>
                    <div className='flex gap-2'>
                        <i class="fi fi-sr-phone-flip text-orange-500"></i><h4><a href={`tel:${mainPhone}`}>{mainPhone}</a></h4>
                    </div>
                </div>

                <img src={shopAvatar} alt="" className='w-48 rounded-3xl my-2' />

                {/* Buttons */}
                <div className='flex gap-2'>
                    <a href={`tel:${mainPhone}`}><PrimaryButton text={"Prenota spiedo"} /></a>
                </div>

                {/* Reviews */}
                <div className='flex flex-col md:items-center'>
                    <h4>Recensioni:</h4>
                    <hr className='h-[1px] w-full bg-orange-500' />

                    <div className='flex flex-col items-start md:items-center gap-4 p-2 rounded-lg'>

                        {reviews.length === 0 && <p>Ancora nessuna recensione per questa attività</p>}

                        {/* Blocco recensioni */}
                        {reviews.length !== 0 &&
                            <div className='flex items-center gap-4 my-4'>
                                <div><i class="fi fi-sr-angle-small-down text-cyan-600 text-3xl"></i></div>
                                {/* Sostituire con iterazione recensioni */}
                                <div className='flex flex-col gap-2 overflow-scroll scrollbar h-56 pr-4'>

                                    {
                                        reviews.map((review) => (
                                            <ReviewBox
                                                createdAt={review.createdAt}
                                                revName={review.revName}
                                                revSurname={review.revSurname}
                                                text={review.text}
                                                rating={review.rating}
                                            />
                                        ))
                                    }

                                </div>
                            </div>}


                    </div>
                    <hr className='h-[1px] w-full bg-orange-500' />
                </div>

                {/* Blocco aggiunta recensione */}
                <div className='flex justify-start items-center w-fit gap-2 border border-orange-500 rounded-lg p-2 cursor-pointer' onClick={handleReviewOpen}>
                    <i class="fi fi-rr-add text-cyan-600 text-4xl mb-[-7px]"></i>
                    <p>Scrivi una recensione</p>
                </div>

                {
                    isReviewOpen &&
                    <AddReview click={handleReviewClose} shopId={shopId} />
                }

                {
                    isPremium && <OfferBox />
                }

            </div>
            <div className='absolute bottom-2 right-3 text-[10pt]'><span className='text-cyan-600'>Sei tu il titolare di questa attività?</span> <span className='text-orange-500 cursor-pointer'>Faccelo sapere!</span></div>
        </div>
    )
}

export default ShopCard;